import { render } from "./activeContents.vue?vue&type=template&id=b669a732&scoped=true"
import script from "./activeContents.vue?vue&type=script&lang=js"
export * from "./activeContents.vue?vue&type=script&lang=js"

import "./activeContents.vue?vue&type=style&index=0&id=b669a732&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b669a732"]])

export default __exports__